export default "__VITE_ASSET__c6c9d8b4__"